<template>
  <div ref="DropdownSelectMenuButton" class="dropdown-select-menu-wrap">
    <p v-if="title" class="title">{{ $t(title) }}<span v-if="required">*</span></p>
    <label v-if="hasCheckBox" class="checkbox-item">
      <input :value="isCheckBoxSelect" type="checkbox" @input="$_checkBoxSelect($event)" />
      <i class="icon-check-box-outline-blank" />
      <i class="icon-check-box" />
      <p>{{ checkboxText }}</p>
    </label>
    <ValidationProvider v-slot="{ errors }" class="dropdown-wrap" :rules="rules">
      <input type="hidden" :value="value" />
      <div v-click-outside="$_dropdownClose" class="dropdown-menu-button-wrap">
        <div
          class="dropdown-menu-button"
          :class="{
            outline: outline,
            avatarButton: avatarButton,
            error: errors.length > 0,
            disabled: disabled,
          }"
        >
          <i
            v-if="leadingIcon && !_computedButtonAvatar"
            class="icon leading-icon"
            :class="[leadingIcon, { selected: value }]"
          />
          <button
            class="input-button"
            :class="{ 'has-cancel-icon': _isDisplayCancelIcon }"
            @click="$_onclick($event)"
          >
            <div
              v-if="avatarButton && _computedButtonAvatar"
              class="avatar"
              :style="{ backgroundImage: 'url(' + _computedButtonAvatar + ')' }"
              style="margin-right: 6px"
            />
            <p v-if="avatarButton && _computedButtonAvatar" class="select input-button_title">
              {{ _computedButtonTextLabel }}
            </p>
            <p v-else class="input-button_title" :class="{ selected: value }">
              {{ _computedButtonTextLabel }}
            </p>
          </button>
          <div v-if="!avatarButton">
            <i
              v-if="outline"
              class="icon trailing-icon outline icon-chevron-up"
              :class="{ show: dropDownMenuShow }"
            />
            <i
              v-else-if="!outline && !dropDownMenuShow"
              class="icon trailing-icon icon-arrow-drop-down-circle"
            />
            <i
              v-else-if="!outline && dropDownMenuShow"
              class="icon trailing-icon icon-arrow-drop-up-circle"
            />
            <i
              v-if="_isDisplayCancelIcon"
              class="icon cancel-icon icon-cancel"
              @click.stop="$_onCancel($event)"
            />
          </div>
        </div>
        <transition mode="out-in">
          <div
            v-if="dropDownMenuShow"
            class="dropdown-menu"
            :class="{
              priority: priority,
              avatarButton: avatarButton,
              'expand-upward': expandUpward,
              'drop-up': scroll !== undefined ? isDropUp : false,
            }"
          >
            <div class="search-tool">
              <SearchInput
                v-model="searchInputButton.value"
                :placeholder="searchInputButton.placeholder"
                :text-label="searchInputButton.textLabel"
                @enter="$_searchDropdown()"
              />
            </div>
            <perfect-scrollbar
              v-scroll:throttle="{ fn: $_onScroll, throttle: 32 }"
              class="ps dropdown-scrollable-content"
            >
              <DotLoading v-if="isLoading && !_dropdownItems.length" />
              <div
                v-for="(item, item_k) in _dropdownItems"
                v-else-if="_dropdownItems.length"
                :key="item_k"
                class="dropdown-menu-item"
                :class="{ selected: $_selectedItem(item), textItem: textItem }"
                @click="$_selectMenuItem(item)"
              >
                <div
                  v-if="avatarSelect && isShowAvatar"
                  class="avatar"
                  :style="{
                    backgroundImage: item.avatar
                      ? 'url(' + item.avatar + ')'
                      : 'url(' + require('@/assets/image/avatar.svg') + ')',
                  }"
                />
                <p>{{ $_dropdownItemText(item) }}</p>
              </div>
              <div v-else-if="!isLoading && !_dropdownItems.length" class="dropdown-menu-item">
                {{ $t(emptyText) }}
              </div>
              <DotLoading v-if="isLoading && _dropdownItems.length" />
            </perfect-scrollbar>
            <div v-if="priority" class="add-btn" @click="$_addFieldOpen()">
              <WsTextButton001
                leading-icon="icon-add-circle"
                primary
                font-size-md
                @click="$_addFieldOpen()"
              >
                {{ $t(addTextLabel) }}
              </WsTextButton001>
            </div>
          </div>
        </transition>
        <transition mode="out-in">
          <ValidationObserver
            v-if="isAddActive"
            ref="memberObserver"
            class="dropdown-menu"
            :class="{ show: isAddActive }"
          >
            <div class="menu-title">
              <i class="icon-arrow-left menu-title_icon" @click="$_addFieldClose()" />
              <p class="menu-title_text">
                {{ $t(addTextLabel) }}
              </p>
            </div>
            <div class="dropdown-content">
              <LlState
                v-for="(fieldItem, fieldKey) in addFieldsType"
                :key="fieldKey"
                v-model="addFields[fieldKey]"
                :title="fieldItem.title"
                :placeholder="fieldItem.placeholder"
                :is-required="fieldItem.required"
                :is-outline="fieldItem.isOutline"
                :rules="fieldItem.rules"
                :type="fieldItem.type"
                :menu="fieldItem.menu"
                :all-select-text="fieldItem.allSelectText"
              />
              <div class="btns">
                <div class="btn">
                  <WsButton001 out-line narrow @click="$_addFieldClose()">
                    {{ $t('取消') }}
                  </WsButton001>
                </div>
                <div class="btn">
                  <WsButton001 @click="$_addSubmitClick()">
                    {{ $t('送出') }}
                  </WsButton001>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </transition>
      </div>
      <div v-if="errors.length > 0 && !noErrorText" class="invalid-text">
        <i class="icon-warning invalid-icon" />
        <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
          {{ $t(text_e) }}
        </p>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import H_user from '@/helpers/user';
import H_common from '@/helpers/common';
import H_dropdown from '@/helpers/dropdown';

extend('required', {
  ...required,
  message: '此項目為必填',
});
extend('email', {
  ...email,
  message: 'email格式不符',
});

export default {
  name: 'DropdownSelectMenuButton',
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    expandUpward: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
    },
    selectValue: {
      type: Object,
      default() {
        return {};
      },
    },
    leadingIcon: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: Boolean,
      default: false,
    },
    avatarButton: {
      type: Boolean,
      default: false,
    },
    addTextLabel: {
      type: String,
      default: '',
    },
    avatarSelect: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    textItem: {
      type: Boolean,
      default: false,
    },
    noErrorText: {
      type: Boolean,
      default: false,
    },
    modelName: {
      type: String,
      default: '',
    },
    hasCheckBox: {
      type: Boolean,
      default: false,
    },
    isCheckBoxSelect: {
      type: Boolean,
      default: false,
    },
    checkboxText: {
      type: String,
      default: '',
    },
    resetPlaceholder: {
      type: Boolean,
      default: false,
    },
    modelParams: {
      type: Object,
    },
    emptyText: {
      type: String,
      default: '無資料',
    },
    scroll: {
      type: Number,
    },
    isShowAvatar: {
      type: Boolean,
      default: false,
    },
    hasCancelIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropDownMenuShow: false,
      searchInputButton: {
        value: '',
        placeholder: this.$t('搜尋'),
        textLabel: this.$t('搜尋'),
      },
      isAddActive: false,
      addName: '',
      addEmail: '',
      addFields: {},
      addFieldsType: {},
      memberFields: {
        name: '',
        email: '',
      },
      contractorFields: {
        name: '',
        tax_id: '',
        task_description: '',
      },
      memberFieldsType: {
        name: {
          title: this.$t('人員名稱'),
          placeholder: this.$t('輸入'),
          type: 'text',
          rules: 'required',
          required: true,
        },
        email: {
          title: this.$t('信箱'),
          placeholder: this.$t('請輸入電子信箱'),
          type: 'text',
          rules: 'email',
          required: false,
        },
      },
      contractorFieldsType: {
        name: {
          title: this.$t('名稱'),
          placeholder: this.$t('輸入'),
          type: 'text',
          rules: 'required',
          required: true,
        },
        tax_id: {
          title: this.$t('統一編號'),
          placeholder: this.$t('輸入'),
          type: 'text',
          rules: 'required',
          required: true,
        },
        task_description: {
          title: this.$t('承攬業務'),
          placeholder: this.$t('請輸入承攬業務'),
          type: 'text',
          rules: 'required',
          required: true,
        },
        system_subclasses: {
          title: this.$t('領域'),
          placeholder: this.$t('選擇'),
          type: 'multiple-layer-select',
          isOutline: true,
          rules: 'required',
          required: true,
          allSelectText: this.$t('全部'),
        },
      },
      dropdownMenuItem: [],
      position: { scrollTop: 0, scrollLeft: 0 },
      scrollTotalHeight: 0,
      windowTotalHeight: 0,
      currentPage: 1,
      lastPage: 1,
      C_selectValue: {},
      isStart: false,
      isLoading: false,
      isDropUp: false,
      dropdownHeight: 0,
      dropdownTop: 0,
      windowHeight: 0,
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _computedButtonTextLabel() {
      let placeholder = this.$t(this.placeholder);
      if (this.resetPlaceholder) {
        this.$_restSelectValue();
        return placeholder;
      }
      if (!this.C_selectValue || Object.keys(this.C_selectValue).length === 0) return placeholder;
      return this.C_selectValue.name;
    },
    _computedButtonAvatar() {
      if (
        !this.avatarButton ||
        !this.C_selectValue ||
        Object.keys(this.C_selectValue).length === 0
      ) {
        return;
      }
      return this.C_selectValue.avatar;
    },
    _dropdownItems() {
      return this.dropdownMenuItem;
    },
    _allSystemClass() {
      if (!this.$store.state.model.systemClasses) {
        return [];
      } else {
        return this.$store.state.model.systemClasses;
      }
    },
    _systemClassMenu() {
      let menu = JSON.parse(JSON.stringify(this._allSystemClass));
      let menuData = [];
      menu.forEach(menuItem => {
        let item = {};
        item.title = menuItem.name;
        item.menu = menuItem.system_subclasses;
        menuData.push(item);
      });
      menuData.forEach((menuItem, menuIndex) => {
        menuItem.menu.forEach((systemItem, systemIndex) => {
          let systemData = {};
          systemData.text = systemItem.name;
          systemData.value = systemItem.id;
          menuData[menuIndex].menu[systemIndex] = systemData;
        });
      });
      return menuData;
    },
    _contractorFieldsType() {
      let _contractorFieldsType = { ...this.contractorFieldsType };
      _contractorFieldsType.system_subclasses.menu = this._systemClassMenu;
      return _contractorFieldsType;
    },
    _isDisplayCancelIcon() {
      return (
        this.hasCancelIcon &&
        this.value != null &&
        this.value !== '' &&
        !this.disabled
      );
    },
  },
  watch: {
    selectValue: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (!this.selectValue || Object.keys(this.selectValue).length === 0) return;
        this.C_selectValue = newValue;
      },
    },
    _contractorFieldsType: {
      handler() {
        this.$_getAddField();
      },
      deep: true,
    },
    value: {
      handler() {
        if (!this.value) {
          this.C_selectValue = {};
        }
      },
    },
    scroll() {
      this.$_getDropdownHeight();
      this.$_isDropUp();
    },
  },
  created() {
    window.addEventListener('resize', this.$_handleResize);
    window.addEventListener('resize', this.$_getDropdownHeight);
    window.addEventListener('resize', this.$_isDropUp);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
    window.removeEventListener('resize', this.$_getDropdownHeight);
    window.removeEventListener('resize', this.$_isDropUp);
  },
  mounted() {
    this.$_getAddField();
    this.$_getDropdownHeight();
    this.$_isDropUp();
  },
  methods: {
    $_restSelectValue() {
      this.C_selectValue = {};
    },
    $_checkBoxSelect($event) {
      this.$emit('checkbox-select', $event.target.checked);
    },
    $_getAddField() {
      if (this.modelName === 'contractor') {
        this.addFields = this.contractorFields;
        this.addFieldsType = this._contractorFieldsType;
      } else {
        this.addFields = this.memberFields;
        this.addFieldsType = this.memberFieldsType;
      }
    },
    $_onScroll(e, position) {
      this.scrollTotalHeight = e.target.scrollHeight;
      this.windowTotalHeight = e.target.offsetHeight;
      this.position = position;
      this.$_scrollBottomGetDropdown();
    },
    $_onclick() {
      if (this.disabled) return;
      this.$_toggleDropdownMenuShow();
    },
    $_toggleDropdownMenuShow() {
      this.dropDownMenuShow = !this.dropDownMenuShow;
      if (this.dropDownMenuShow) {
        this.$_getDropdownMenu();
        this.isStart = false;
      } else {
        this.$_dropdownClose();
      }
    },
    $_selectMenuItem(item) {
      this.$emit('input', item.id);
      this.$emit('input-item', item);
      this.dropDownMenuShow = false;
      this.C_selectValue = item;
    },
    $_selectedItem(item) {
      if (this.value == item.id) {
        return true;
      } else {
        return false;
      }
    },
    $_selectedItemNum(select, list) {
      if (list.length === 0) return;
      if (!select) {
        return;
      }
      let allId = list.map(item => {
        return item.id;
      });
      let selectedNum = allId.indexOf(select);
      return selectedNum;
    },
    $_dropdownClose() {
      this.dropDownMenuShow = false;
      this.isAddActive = false;
      this.currentPage = 1;
      this.searchInputButton.value = '';
      this.dropdownMenuItem = [];
    },
    $_addFieldOpen() {
      this.isAddActive = true;
      this.dropDownMenuShow = false;
    },
    $_addFieldClose() {
      this.isAddActive = false;
      this.$_onclick();
    },
    $_searchDropdown() {
      this.$_getDropdownMenu('search');
    },
    async $_addSubmitClick() {
      const isValidate = await this.$refs.memberObserver.validate();
      if (!isValidate) {
        return;
      }
      let getUrl = '';
      if (this.modelName === 'contractor') {
        getUrl = `/factory/${this._currentFactoryId}/contractor`;
      } else {
        getUrl = `/factory/${this._currentFactoryId}/user`;
      }
      try {
        const res = await this.$axios.post(getUrl, this.addFields);
        let addMember = res.data.data;
        let addElementId = res.data.data.id;
        let dropdownItems =
          this.modelName === 'contractor'
            ? [res.data.data]
            : H_user.setDropdownMenuList([res.data.data]);
        this.C_selectValue = addMember;
        this.dropdownMenuItem = dropdownItems.concat(this.dropdownMenuItem);
        this.$emit('input', addElementId);
        this.$_dropdownClose();
        this.$_clearSubmit();
      } catch (err) {
        alert(this.$t('新增發生錯誤'));
      }
    },
    $_clearSubmit() {
      this.addFields = {};
    },
    async $_getDropdownMenu(type) {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        if (type === 'search') {
          this.currentPage = 1;
        }
        let params = {
          page: this.currentPage,
          search: this.searchInputButton.value,
          factory: this._currentFactoryId,
          target_factory: this._currentFactoryId,
        };
        if (this.modelParams) {
          params = { ...params, ...this.modelParams };
        }
        let getUrl = '';
        if (this.modelName === 'contractor') {
          getUrl = `/v2/factory/${this._currentFactoryId}/contractor`;
        } else {
          getUrl = `/factory/${this._currentFactoryId}/simplify_factory_index`;
        }
        const res = await this.$axios.get(getUrl, {
          params: params,
        });
        let dropdownItems =
          this.modelName === 'contractor'
            ? res.data.data
            : H_user.setDropdownMenuList(res.data.data);
        this.lastPage = res.data.meta.last_page;
        if (type === 'search') {
          this.dropdownMenuItem = dropdownItems;
        } else {
          this.dropdownMenuItem = this.dropdownMenuItem.concat(dropdownItems);
        }
        this.isLoading = false;
      } catch (err) {
        alert(this.$t('取得列表錯誤'));
      }
    },
    $_scrollBottomGetDropdown() {
      const allScrollHeight = this.scrollTotalHeight - this.windowTotalHeight;
      const scrollHeight = this.position.scrollTop;
      if (scrollHeight / allScrollHeight > 0.95 && !this.isLoading) {
        if (this.currentPage < this.lastPage) {
          this.currentPage += 1;
          this.$_getDropdownMenu();
        }
      }
    },
    $_dropdownItemText(item) {
      return H_dropdown.getListOfContractorOrAvatar(this.modelName, item);
    },
    $_handleResize() {
      this.windowHeight = window.innerHeight;
    },
    $_getDropdownHeight() {
      const { height, y } = H_common.getComponentHeightAndY(this.$refs.DropdownSelectMenuButton);
      this.dropdownHeight = height;
      this.dropdownTop = y;
    },
    $_isDropUp() {
      this.isDropUp = H_common.isDropUp(this.dropdownHeight, this.dropdownTop, 350, 350);
    },
    $_onCancel() {
      this.$emit('input', null);
      this.$emit('input-item', null);
      this.C_selectValue = {};
      this.dropDownMenuShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/dropdown-select-menu-button';
</style>
